module.exports = __webpack_public_path__ + "static/img/industrial1.f10c2a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industrial/industrial1.png
// module id = i79Q
// module chunks = 11